import { fetchSplitTreatments, trackSplitEvent } from 'lib/clients/split';

const createBrowserSplitClient = ({ id }) => {
  return {
    getTreatments: async (splits, attributes) => {
      return await fetchSplitTreatments({ id, splits, attributes });
    },

    track: (event, value, properties) => {
      return trackSplitEvent({ id, event, value, properties });
    },
  };
};

export default createBrowserSplitClient;
